import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { FlexRow, LinkTextRow } from '@app/flex-framework/flex-api.model';
import { TrackerService } from '@app/shared/services/tracker.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-link-text-row',
  templateUrl: './link-text-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkTextRowComponent implements OnChanges {
  @Input() public row: FlexRow;

  public i18n = this.translate.instant([
    'dgFlexRow_EditDetails',
    'dgFlexRow_RemoveSection',
    'Core_Options',
  ]);
  public linkTextRow: LinkTextRow;

  constructor(
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private trackerService: TrackerService
  ) {}

  public ngOnChanges() {
    this.setupRowData(this.row.targetResources[0]?.reference);
    this.cdr.markForCheck();
  }

  public setupRowData(row: LinkTextRow) {
    this.linkTextRow = row;
  }

  public trackClick() {
    this.trackerService.trackEventData({
      action: 'Call to Action Button Clicked',
      category: 'Career Pathing',
      properties: this.linkTextRow,
    });
  }
}
